"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReliablePartnerStatus = exports.reliablePartnerStatusText = void 0;
var React = require("react");
var classnames = require("classnames");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./index.scss");
var reliablePartnerStatusText = function (status) {
    return !status || status === 'UNKNOWN'
        ? '-'
        : (0, translation_1.getLocalization)("reliablePartnerStatus/".concat(status));
};
exports.reliablePartnerStatusText = reliablePartnerStatusText;
var ReliablePartnerStatus = function (props) {
    var _a;
    return (React.createElement("span", { className: classnames('reliable-partner-status', (_a = props.status) !== null && _a !== void 0 ? _a : 'UNKNOWN') }, props.text));
};
exports.ReliablePartnerStatus = ReliablePartnerStatus;
